import React, { Fragment } from "react"
import PropTypes from "prop-types"

import Header from "./Header"
import Main from "./Main"
import CustomerProvider from "../CustomerProvider/index"
import AccessControlProvider from "../AccessControlProvider"

const ModernLayout = ({ children, ...props }) => {
  return (
    <Fragment>
      <Header />
      <Main {...props}>
        <CustomerProvider {...props}>
          <AccessControlProvider path={props.path}>
            {children}
          </AccessControlProvider>
        </CustomerProvider>
      </Main>
    </Fragment>
  )
}

ModernLayout.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string
}

export default ModernLayout



// WEBPACK FOOTER //
// ./src/components/ModernLayout/index.js